var map = {
	"./gls/en.json": "6a0f",
	"./gls2/en.json": "da39",
	"./gps/en.json": "c3d9",
	"./ics/en.json": "e161",
	"./ics2/en.json": "003c",
	"./loomis/en.json": "aef9",
	"./loomis2/en.json": "a8d1",
	"./puro/en.json": "4f33",
	"./puro2/en.json": "0f64"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2d93";